<div class="password-field__input-container">
  <input mmInput
         class="password-field__input"
         [autocomplete]="autoCompletePassword"
         [type]="isPasswordVisible ? 'text' : 'password'"
         [placeholder]="placeholder | translate"
         [value]="value"
         (change)="onChangePassword($event)"
         (blur)="onTouched()"
         [mmTestTarget]="'field-' + formControlName">
  <div class="password-field__button-container">
    <button mm-button
            color="ghost"
            size="small"
            iconOffset="false"
            tabindex="-1"
            [iconButton]="true"
            (click)="onChangePasswordVisibility()"
            [mmTestTarget]="'field-' + formControlName + '-visibility-button'">
      <mm-icon *ngIf="!isPasswordVisible" name="visibility"></mm-icon>
      <mm-icon *ngIf="isPasswordVisible" name="visibility-off"></mm-icon>
    </button>
  </div>
</div>
